import React from "react";
import { TextField, Typography, Box } from "@mui/material";
import styled from "@emotion/styled";

const FormField = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const IntroText = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const StepChecklistBasics = ({ form, onChange }) => (
    <>
        <IntroText variant="body2" color="text.secondary">
            Name this list of steps so your team can find it later. A checklist template is never run on its own — its steps get added to a task's checklist when someone imports
            it.
        </IntroText>

        <FormField>
            <TextField
                fullWidth
                label="Name"
                name="name"
                value={form.name}
                onChange={onChange}
                required
                autoFocus
                placeholder="e.g. New site launch checks"
                helperText="Shown in the list people pick from when importing into a task."
            />
        </FormField>

        <FormField>
            <TextField
                fullWidth
                multiline
                minRows={3}
                label="Description"
                name="description"
                value={form.description}
                onChange={onChange}
                placeholder="e.g. Run through these before handing a new site to the client."
                helperText="Optional. A short note explaining when this checklist should be used."
            />
        </FormField>
    </>
);

export default StepChecklistBasics;
